<div class=" expanded align-middle navigation-bar-container">
	<div class="small-6 columns title ">
		{{title}}
	</div>
</div>
